module.exports = __webpack_public_path__ + "static/media/download (2).59d6e13d.png";